<template>
  <div class="delay-block">
    <h3 class="delay-block__title">{{ $t('view.flow.block.delayCancel.title') }}</h3>
    <div class="delay-block__time-row">
      <in
        class="delay-block__input"
        v-model="val.name"
        :label="$t('view.flow.block.delayCancel.name')"
        @input="onInput"
      ></in>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.delay-block {
  @include flowElementShadow();
  width: 30%;
  min-width: 380px;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }
}
</style>
